import { useQuery } from '@apollo/client';
import { Autocomplete, FormLabel, Grid, TextField } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import QUERY from 'gql/queries/getUsers.gql';

import GQLGuard from 'app/components/GQLGuard';
import { actions as AlertActions } from 'app/containers/Dashboard/Alert/slice';
import { translations } from 'locales/i18n';
import { UserType } from 'utils/ACLHelper';

interface Props {
  recipients: any;
}

export function ArticleInspection(props: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const reachedUsersQuery = useQuery<
    any,
    { type?: string; application?: string; entitlements?: []; withDisabled?: string }
  >(QUERY, {
    fetchPolicy: 'no-cache',
    variables: {
      type: UserType.SHIBBOLETH,
      entitlements: props.recipients,
      withDisabled: 'active'
    },
    context: { clientName: 'federation' }
  });
  return (
    <GQLGuard
      query={[reachedUsersQuery]}
      onError={error => {
        dispatch(AlertActions.error(`${t(translations.pages.articleDetail.errorLoading())}`));
        navigate('/articles', { replace: true });
        return null;
      }}
    >
      {([userData]) => {
        return (
          <>
            <Grid container>
              <FormLabel className="articleModal__body__input__label">
                {t(translations.pages.articles.create.general.recipients())}
              </FormLabel>
              <Autocomplete
                multiple
                value={props.recipients}
                disabled
                options={props.recipients}
                fullWidth
                renderInput={params => <TextField {...params}></TextField>}
              />
              <FormLabel className="articleModal__body__input__label">
                {t(translations.pages.articles.inspect.reachedUsers())}
              </FormLabel>
              <Grid container>{userData.usersCount}</Grid>
            </Grid>
          </>
        );
      }}
    </GQLGuard>
  );
}
